<template>
  <b-modal
    id="modal-select-pool"
    centered
    :title="header"
    :hide-header="!header"
    hide-footer
    :size="size || 'md'"
    :no-close-on-backdrop="true"
  >
    <b-form @submit.prevent="submit">
      <b-form-group id="input-group-pools">
        <v-select
          v-model="localPool"
          v-validate="{ required: true }"
          :options="poolOptions"
          label="name"
          placeholder="Select a pool"
          data-vv-name="pool"
        ></v-select>
      </b-form-group>

      <b-row>
        <b-col class="text-right">
          <b-btn variant="primary" type="submit">Select</b-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import vSelect from "vue-select";
import { mapGetters } from "vuex";

export default {
  name: "PoolSelectModal",
  components: {
    vSelect
  },
  props: {
    header: {
      type: String,
      required: false,
      default: null
    },
    size: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      localPool: null
    };
  },
  computed: {
    ...mapGetters(["poolsByDateDesc"]),
    poolOptions() {
      return this.poolsByDateDesc.filter(p => p.status.code === 4 && p.user_allowed.includes("Owner"))
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$toasted.show(this.$validator.errors.items[0].msg, {
            type: "error"
          });
          return false;
        }
        this.$bvModal.hide("modal-select-pool");
        this.$emit("submit", this.localPool);

        this.localPool = null;
      });
    }
  }
};
</script>
